import bem from '../../../../utils/bem';
import Icon from '../../../Atoms/Icon/Icon';
import useWindowWidth from '../../../../hooks/useWindowWidth';

// Utility function to strip HTML tags
const stripHtmlTags = (text) => {
  if (!text) return '';
  return text.replace(/<[^>]*>/g, '').trim();
};

const JobsCollection = ({ products }) => {
  const { breakpoint } = useWindowWidth();
  const itemBaseClass = 'jobs-collection-item';
  if (!products || products.length === 0) {
    return <div>No job data available.</div>;
  }

  return (
    <div className={bem(itemBaseClass)}>
      {!breakpoint.isMobile && (
        <table className={bem('jobs-collection')}>
          <thead>
            <tr>
              <th>Job Title</th>
              <th>Location</th>
              <th>Job Level</th>
              <th>Brand</th>
              <th>Post Date</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product.nid}>
                <td className="job-title">
                  <a href={stripHtmlTags(product.cta_link)}>
                    {stripHtmlTags(product.title) || 'No Title'}
                  </a>
                </td>
                <td className="job-location">
                  {stripHtmlTags(product.city) || stripHtmlTags(product.states)
                    ? `${stripHtmlTags(product.city)}${
                        stripHtmlTags(product.city) &&
                        stripHtmlTags(product.states)
                          ? ', '
                          : ''
                      }${stripHtmlTags(product.states)}`
                    : stripHtmlTags(product.country) || ''}
                </td>
                <td>
                  {stripHtmlTags(product.job_level) ||
                    'Job Level not specified'}
                </td>
                <td className="job-brand">
                  <img
                    src={stripHtmlTags(product.brand)}
                    alt={stripHtmlTags(product.brand_title)}
                  />
                </td>
                <td className="post-date">
                  <div className="post-date__items">
                    <span>{product.post_date || 'Date not available'}</span>
                    <a
                      href={stripHtmlTags(product.cta_link)}
                      className="btn btn--primary"
                    >
                      {Drupal.t('View Job')}
                      <Icon iconName="arrow" />
                    </a>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {breakpoint.isMobile && (
        <>
          {products.map((product) => (
            <div key={product.nid} className="jobs-collection-item__block">
              <div className="jobs-collection-item__block--inner">
                <div className="job-brand">
                  <img
                    src={stripHtmlTags(product.brand)}
                    alt={stripHtmlTags(product.brand_title)}
                  />
                </div>
                <div className="job-title">
                  <a href={stripHtmlTags(product.cta_link)}>
                    {stripHtmlTags(product.title) || 'No Title'}
                  </a>
                </div>
                <div className="job-location">
                  <span>Location:</span>
                  {stripHtmlTags(product.city) || stripHtmlTags(product.states)
                    ? `${stripHtmlTags(product.city)}${
                        stripHtmlTags(product.city) &&
                        stripHtmlTags(product.states)
                          ? ', '
                          : ''
                      }${stripHtmlTags(product.states)}`
                    : stripHtmlTags(product.country) || ''}
                </div>
                <div className="job-level">
                  <span>Job Level:</span>
                  {stripHtmlTags(product.job_level) ||
                    'Job Level not specified'}
                </div>

                <div className="post-date">
                  <span>Post Date:</span>
                  {product.post_date || 'Date not available'}
                </div>
                <div className="view-job">
                  <a
                    href={stripHtmlTags(product.cta_link)}
                    className="btn btn--primary"
                  >
                    {Drupal.t('View Job')}
                    <Icon iconName="arrow" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default JobsCollection;
